import { Contrato } from './../contrato/contrato.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ContratosService {

    constructor(private http: Http){

    }

    getContratos(): Observable<Contrato[]> {
        return this.http.get(`${NTECH_API}/contratos`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getContratoById(id: string): Observable<Contrato>{
        return this.http.get(`${NTECH_API}/contratos/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    gravarContrato(contrato: Contrato): Observable<Contrato> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        if ((contrato.Id !== undefined) && ((contrato.Id.length > 0) || (contrato.Id !== '0'))) {
            return this.http.put(`${NTECH_API}/contratos/${contrato.Id}`, JSON.stringify(contrato), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/contratos`, JSON.stringify(contrato), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/contratos/contratos.services.ts